import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import ApgarScale from "../../data/scales/apgarScale";
import Note from "../../components/note";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <EMTLevel level="advanced" mdxType="EMTLevel">
    <EMTLevel level="paramedic" mdxType="EMTLevel">
      <ul>
        <li>
          1.0 Routine Patient Care—dry, warm, position, stimulate.
        </li>
        <li>
          For newly born requiring resuscitation, see 2.12 Resuscitation of the Newly
          Born.
        </li>
        <li>
          Reassess airway by positioning and clearing secretions (only if needed):
        </li>
        <ul>
          <li>
            Place the newly born on back or side with head in a neutral or slightly
            extended position.
          </li>
          <li>
            Routine suctioning is discouraged even in the presence of meconium-stained
            amniotic fluid. Suction oropharynx then nares only if the patient exhibits
            respiratory depression and/or obstruction, see 2.12 Resuscitation of the
            Newly Born.
          </li>
        </ul>
        <li>Clamp and cut the umbilical cord:</li>
        <ul>
          <li>After initial assessment and after the cord stops pulsating.</li>
          <li>Leave a minimum of 6 inches of cord.</li>
        </ul>
        <li>Prevent heat loss by rapidly drying and warming:</li>
        <ul>
          <li>
            Remove wet linen, wrap newly born in blankets or silver swaddler (preferred)
            and cover newly born’s head.
          </li>
        </ul>
        <li>Assess breathing by providing tactile stimulation:</li>
        <ul>
          <li>Flick soles of feet and/or rub the newly born’s back.</li>
          <li>
            If newly born is apneic or has gasping respirations, nasal flaring, or grunting,
            proceed t2.12 Resuscitation of the Newly Born.
          </li>
        </ul>
        <li>Assess circulation, heart rate, and skin color:</li>
        <ul>
          <li>Evaluate heart rate by one of several methods:</li>
          <ul>
            <li>Auscultate apical beat with a stethoscope.</li>
            <li>Palpate the pulse by lightly grasping the base of the umbilical cord.</li>
          </ul>
        </ul>
        <ul>
          <li>
            If the pulse is &lt; 100 bpm and not increasing, proceed to 2.12 Resuscitation of
            the Newly Born. Assess skin color; examine trunk and face; and mucus
            membranes.
          </li>
        </ul>
        <li>
          Record APGAR score at 1 minute and 5 minutes 
          <a href="#apgar-chart">(see chart).</a>
        </li>
      </ul>
    </EMTLevel>
  </EMTLevel>
    </EMTLevel>
    <ApgarScale mdxType="ApgarScale" />
    <Note id="note-1" alignment="left" mdxType="Note">
  <strong>PEARLS:</strong>
  <ul>
    <li>
      Newly born are prone to hypothermia which may lead to hypoglycemia, hypoxia and lethargy.
      Aggressive warming techniques should be initiated including drying, swaddling, and warm blankets
      covering body and head.
    </li>
    <li>
      Raise temperature in ambulance patient compartment.
    </li>
  </ul>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      